export default class ProductsFilter {

    constructor() {

        this.el = $('.products');

        if (!this.el.length) {
            return false;
        }

        this.state = ProductsFilter.STATE_DEFAULT;
        this.dir = 1;
        this.initialProductsList = this.el.find('.card-multiple'); // Ensure it targets the entire card container
        this.desktopFilterSelector = $('.js-filter');
        this.desktopFilterSelector.find('a').each((index, el) => {
            let link = $(el);
            link.click(() => {
                this.handleSort(link.data('value'));
                return false;
            });
        });

        const context = this;
        this.mobileFilterSelector = $('.js-filter-mobile')
        this.mobileFilterSelector.change(function () {
            context.handleSort(this.value);
        });
    }

    handleSort(value) {

        if (this.state !== value) {
            this.dir = 1;
        }

        this.state = value;

        switch (value) {
            case ProductsFilter.STATE_DEFAULT:
                this.updateSortOrder([].slice.call(this.initialProductsList));
                break;

            case ProductsFilter.STATE_NAME:
                this.sortByName();
                break;

            case ProductsFilter.STATE_PRICE:
                this.sortByPrice();
                break;
        }
    }

    sortByName() {
        var productsList = [].slice.call(this.initialProductsList).sort((a, b) => {
            a = $(a).find('.product').data('product-name');
            b = $(b).find('.product').data('product-name');
            if (typeof a === 'string' && typeof b === 'string') {
                return a.toLowerCase().localeCompare(b.toLowerCase()) * this.dir;
            }
            return 0;
        });

        this.updateSortOrder(productsList);
    }

    sortByPrice() {
        var productsList = [].slice.call(this.initialProductsList).sort((a, b) => {
            a = parseFloat($(a).find('.product').data('product-price'));
            b = parseFloat($(b).find('.product').data('product-price'));
            return (a - b) * this.dir;
        });

        this.updateSortOrder(productsList);
    }

    updateSortOrder(productsList) {
        productsList.forEach(p => {
            this.el.append(p);
        });

        this.dir *= -1;
    }
}

ProductsFilter.STATE_DEFAULT = 'relevance';
ProductsFilter.STATE_PRICE = 'price';
ProductsFilter.STATE_NAME = 'name';